module.exports = __webpack_public_path__ + "static/media/icon_ai-video-analyzer.1f43868a.svg";